export default {
    NAME: 'name',
    CONTENT: 'content',
    HTTP_EQUIV: 'http-equiv',
    PROPERTY: 'property',
    REL: 'rel',
    HREF: 'href',
    SIZES: 'sizes',
    TYPE: 'type',
    TITLE: 'title',
    MEDIA: 'media',
    HREFLANG: 'hreflang',
};
